//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[[0,"GougeCheckStatus",0,0],[0,"GougeOption",0,0],[0,"NumberGouges",0,0],[0,"NumberHolderCollisions",0,0]],[[[],"Dispose",{},0,0],[["num_points"],"GetGougePoints",{R_:{points:""}},0,0],[["num_points"],"GetHolderCollisionPoints",{R_:{points:""}},0,0]],[]];
SPLM.CAM.GougeCheckResults = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.GougeCheckResults";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.GougeCheckResults.Constants = Object.freeze({
    "MaxGouges" : "MaxGouges"});

SPLM.CAM.GougeCheckResults.Option = Object.freeze({
    "None" : "None", "GougeOnly" : "GougeOnly", "GougeAndHolderCollisions" : "GougeAndHolderCollisions", "UseOperation" : "UseOperation"});

SPLM.CAM.GougeCheckResults.Status = Object.freeze({
    "NotChecked" : "NotChecked", "Checked" : "Checked", "Thc" : "Thc", "Gouges" : "Gouges", "ThcGouges" : "ThcGouges", "Warnings" : "Warnings", "Errors" : "Errors"});

export default SPLM;